import React from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from 'react-icons/md';
import { MenuItemComponentProps } from '../types';

const MenuItemComponent: React.FC<MenuItemComponentProps> = ({
  item,
  depth,
  keyPath,
  openKeys,
  selectedKeys,
  handleMenuAction,
}) => {
  const isOpen = openKeys.includes(item.key);
  const isSelected = selectedKeys.includes(item.key);

  const getMenuLevelClasses = (depth: number) => {
    const classLevels = [
      {
        item: 'pl-8',
        bg: 'bg-menu-grey-1', //Default BG
      },
      {
        item: 'pl-9',
        bg: 'bg-menu-grey-2',
      },
      {
        item: 'pl-10',
        bg: 'bg-menu-grey-3',
      },
      {
        item: 'pl-11',
        bg: 'bg-menu-grey-4',
      },
      {
        item: 'pl-12',
        bg: 'bg-menu-grey-5',
      },
    ];

    return classLevels[Math.min(depth, classLevels.length - 1)] || classLevels[0];
  };

  const { item: itemClass, bg: bgClass } = getMenuLevelClasses(depth);

  const getSelectedClass = () => {
    if (!isSelected) return '';
    return selectedKeys.length === depth + 1 ? 'selected-key' : 'selected-key-parent';
  };

  return (
    <li key={item.key} className={`relative my-1 ${getSelectedClass()}`}>
      <div
        className={`${itemClass} flex flex-1 items-center justify-between cursor-pointer h-auto`}
        onClick={() => handleMenuAction(item.key)}
      >
        {item.label}
        {item.children && (
          <div
            className="flex items-center justify-end ml-5"
            onClick={(e) => {
              e.stopPropagation();
              handleMenuAction(item.key);
            }}
          >
            {isOpen ? (
              <MdKeyboardArrowDown className="text-soft-blue-grey ml-2 mr-4" />
            ) : (
              <MdKeyboardArrowRight className="text-soft-blue-grey ml-2 mr-4" />
            )}
          </div>
        )}
      </div>

      {item.children && isOpen && (
        <ul className={`submenu ${bgClass}`}>
          {item.children.map((child) => (
            <MenuItemComponent
              key={child.key}
              item={child}
              depth={depth + 1}
              keyPath={[...keyPath, child.key]}
              openKeys={openKeys}
              selectedKeys={selectedKeys}
              handleMenuAction={handleMenuAction}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

export default MenuItemComponent;
